import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';

const AccountantSubeWorkOrder = () => {
  const [loading, setLoading] = useState(true);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [allWorkOrders, setAllWorkOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    const engRef = ref(db, 'ekamwatapzp/EngineerRegistrations');
    
    onValue(engRef, (snapshot) => {
        if (snapshot.exists()) {
            const data = snapshot.val();
            let recordsArray = [];
            let datesSet = new Set();
            let count = 1;

            Object.keys(data).forEach(userId => {
                const user = data[userId];
                if (user.GeneratedLottery) {
                    Object.keys(user.GeneratedLottery).forEach(dateStr => {
                        datesSet.add(dateStr);
                        const lotteryData = user.GeneratedLottery[dateStr];
                        const amountToDisplay = lotteryData.tenderAmount || lotteryData.estimatedCost || "-";
                        
                        recordsArray.push({
                            id: count++,
                            userId: userId,
                            dateStr: dateStr,
                            taluka: user.taluka || "उपलब्ध नाही",
                            schemeName: lotteryData.schemeName || "योजनेचे नाव उपलब्ध नाही",
                            workName: lotteryData.workName || "-",
                            amount: amountToDisplay,
                            subEngineerName: user.firstName ? `${user.firstName} ${user.middleName || ''} ${user.surname || ''}`.trim() : (user.fullName || user.name || "उपलब्ध नाही"),
                            // Additional data fields for Print Order
                            panNo: user.panNo || "----",
                            gstNo: user.gstNo || "----",
                            bankAccountNo: user.bankAccountNo || "----",
                            bankName: user.bankName || "DCC बँक",
                            mobile: user.whatsappNo || user.mobileNo || "----",
                            address: user.address || `मु.पो. ${user.taluka || 'उपलब्ध नाही'}, जि. सांगली.`,
                            estimatedAmount: amountToDisplay,
                            meetingDate: dateStr
                        });
                    });
                }
            });

            // Sort dates
            const sortedDates = Array.from(datesSet).sort((a, b) => {
                const [dayA, monthA, yearA] = a.split('-');
                const [dayB, monthB, yearB] = b.split('-');
                return new Date(yearB, monthB - 1, dayB) - new Date(yearA, monthA - 1, dayA);
            });

            setAvailableDates(sortedDates);
            if (sortedDates.length > 0) {
                setSelectedDate(sortedDates[0]);
            }
            setAllWorkOrders(recordsArray);
        }
        setLoading(false);
    });
  }, []);

  const handleSearch = () => {
    // Already filtered by selectedDate inline
  };

  const handleCopy = () => {
    console.log('Copy data');
  };

  const handleExcel = () => {
    console.log('Export to Excel');
  };

  const handlePrint = () => {
    console.log('Print data');
  };

  const handleLetterClick = (item) => {
    const params = new URLSearchParams({
      id: item.userId || item.id || '',
      taluka: item.taluka || '',
      schemeName: item.schemeName || '',
      workName: item.workName || '',
      subEngineerName: item.subEngineerName || '',
      panNo: item.panNo || '',
      gstNo: item.gstNo || '',
      bankAccountNo: item.bankAccountNo || '',
      bankName: item.bankName || '',
      mobile: item.mobile || '',
      address: item.address || '',
      estimatedAmount: item.estimatedAmount || '',
      date: item.dateStr || '',
      meetingDate: item.meetingDate || ''
    });
    window.open(`/accountant/subhe-work-order-print?${params.toString()}`, '_blank');
  };

  const filteredData = allWorkOrders.filter(item => {
      const matchesDate = item.dateStr === selectedDate;
      const term = searchTerm.toLowerCase();
      const matchesSearch = item.taluka.toLowerCase().includes(term) ||
                            item.workName.toLowerCase().includes(term) ||
                            item.subEngineerName.toLowerCase().includes(term);
      return matchesDate && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-slate-800 text-white shadow-md">
        <div className="container mx-auto px-6 py-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-2">सु.बे. अभियंता शिफारस पत्र यादी</h1>
            <div className="w-24 h-0.5 bg-blue-400 mx-auto mb-3"></div>
            <h2 className="text-lg font-normal">जिल्हा परिषद / सु.बे. अभियंता शिफारस पत्र यादी</h2>
          </div>
        </div>
      </div>

      {/* Search and Action Section */}
      <div className="container mx-auto px-6 py-6">
        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
            {/* Left side - Date picker and action buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <div className="flex flex-col">
                <label htmlFor="lottery-date" className="text-gray-700 font-medium mb-1">
                  लॉटरीची तारीख निवडा
                </label>
                <select
                  id="lottery-date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none"
                >
                    {availableDates.length > 0 ? (
                        availableDates.map(date => (
                            <option key={date} value={date}>{date}</option>
                        ))
                    ) : (
                        <option value="">तारीख उपलब्ध नाही</option>
                    )}
                </select>
              </div>
              <button 
                onClick={handleSearch}
                className="bg-blue-600 text-white px-6 py-2 rounded font-medium hover:bg-blue-700 transition-colors mt-[28px]"
              >
                Search
              </button>
              <div className="flex gap-2 mt-[28px]">
                <button 
                  onClick={handleCopy}
                  className="bg-gray-600 text-white px-4 py-2 rounded font-medium hover:bg-gray-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Copy
                </button>
                <button 
                  onClick={handleExcel}
                  className="bg-green-600 text-white px-4 py-2 rounded font-medium hover:bg-green-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Excel
                </button>
                <button 
                  onClick={handlePrint}
                  className="bg-purple-600 text-white px-4 py-2 rounded font-medium hover:bg-purple-700 transition-colors flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                  </svg>
                  Print
                </button>
              </div>
            </div>

            {/* Right side - Search input */}
            <div className="flex items-center gap-2 mt-[28px] lg:mt-0">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none w-64 lg:mt-[28px]"
              />
              <svg className="w-5 h-5 text-gray-400 lg:mt-[28px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="mt-6 bg-white rounded-lg shadow border border-gray-200">
          <div className="bg-gray-100 px-4 py-3 border-b border-gray-300">
            <h3 className="text-base font-semibold text-gray-800">सु.बे. अभियंता शिफारस पत्र यादीची माहिती</h3>
          </div>
          
          <div className="overflow-x-auto">
            {loading ? (
                <div className="p-8 text-center text-gray-500">माहिती लोड होत आहे...</div>
            ) : (
                <table className="w-full border-collapse border border-gray-300">
                  <thead className="bg-slate-700 text-white">
                    <tr>
                      <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">क्रमांक</th>
                      <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">तालुका</th>
                      <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">कामाचे नाव</th>
                      <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">रक्कम</th>
                      <th className="px-4 py-3 text-left font-medium text-sm border border-gray-300">अर्जाचे नाव</th>
                      <th className="px-4 py-3 text-center font-medium text-sm border border-gray-300">वर्क ऑर्डर </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {filteredData.length > 0 ? filteredData.map((item, index) => (
                      <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-4 py-3 text-sm font-medium text-gray-900 border border-gray-300">{index + 1}</td>
                        <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.taluka}</td>
                        <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.workName}</td>
                        <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.amount !== "-" ? `₹${item.amount}` : "-"}</td>
                        <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{item.subEngineerName}</td>
                        <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300 text-center">
                          <button 
                            onClick={() => handleLetterClick(item)}
                            className="text-blue-600 hover:text-blue-800 transition-colors mx-auto"
                            title="वर्क ऑर्डर प्रिंट करा"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    )) : (
                        <tr>
                            <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                                {selectedDate ? `दिनांक ${selectedDate} रोजीच्या लॉटरीसाठी कोणताही डेटा आढळला नाही.` : 'कोणतीही माहिती उपलब्ध नाही.'}
                            </td>
                        </tr>
                    )}
                  </tbody>
                </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantSubeWorkOrder;
